import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {MarkExploreAttentionBadgeAsSeen as MarkExploreAttentionBadgeAsSeenMutation} from 'nutshell-graphql-types';

import MARK_EXPLORE_ATTENTION_BADGE_AS_SEEN from '../mutations/mark-explore-attention-badge-as-seen.graphql';

export const useMarkExploreAttentionBadgeAsSeen = (): {
    markExploreAttentionBadgeAsSeen: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [markExploreAttentionBadgeAsSeen, {loading, error}] =
        useMutation<MarkExploreAttentionBadgeAsSeenMutation>(MARK_EXPLORE_ATTENTION_BADGE_AS_SEEN);

    return {
        markExploreAttentionBadgeAsSeen: () => markExploreAttentionBadgeAsSeen(),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
